import React from 'react';
import FormItemContainerControl from './FormItemContainerControl';
import FormItemTableRow from '../FormItemTableRow';



export default class FormItemTableRowControl extends FormItemContainerControl
{
	constructor(menuItemId,formId,parent,xml,group,module,forLookup) {
		super(menuItemId,formId,parent,xml,group,module,forLookup);
		this.classAlias = "FormItemTableRowControl";
	}

	getProperty_Height()
	{
		return this.properties.Height;
    }
    
    getProperty_HorizontalAlignment()
    {
        return "center";//this.properties.HorizontalAlignment;
    }

	getStyle()
	{
		let style = {};
        let _height = this.getProperty_Height();
        if(_height)
        {
            style.height = _height + "px";
        }
		return style;
	}

	getComponentInstance(parent,forLookup)
	{
		this.component = <FormItemTableRow key={this.xml.id} xml={this.xml} moduleInstanceId={this.module.instanceUUId} 
						control={this} forLookup={forLookup} groupAlias={this.groupAlias}
                        customStyle={this.getStyle()} formId={this.formId} menuItemId={this.menuItemId}
                        contextMenuData={this.contextMenuData} />;
		return this.component;
	}
}



// WEBPACK FOOTER //
// ./src/formItem/controls/FormItemTableRowControl.js